import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import TextBase from '@components/common/core/DataDisplay/Text';
import CheckboxBase from '@components/common/core/Inputs/Checkbox';
import InputGroupBase from '@components/common/core/Inputs/InputGroup';
import LabelBase from '@components/common/core/DataDisplay/Label';
import ButtonBase from '@components/common/core/Inputs/Button';

export const Title = styled(HeadingBase)``;

export const LoadingWrapper = styled.div`
  width: 100%;
  padding: 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddButton = styled(ButtonBase)`
  white-space: nowrap;
`;

export const Checkbox = styled(CheckboxBase)``;

export const CheckboxLabel = styled(LabelBase)`
  margin: unset;
  margin-top: 1px;
  cursor: pointer;
`;

export const CheckboxGroup = styled(InputGroupBase)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: unset;
`;

export const CheckboxAndAddButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 582px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const InsightText = styled(TextBase)`
  font-size: 0.875rem;
`;

export const DetectedCampaigns = styled.button`
  display: inline-block;
  margin: unset;
  padding: unset;
  background-color: unset;
  border: unset;
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.green.default};
  text-decoration: underline;
  font-weight: 700;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }
`;

export const InsightIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

export const Insight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
`;

export const Description = styled(TextBase)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray[2]};
  line-height: 120%;
  margin-top: 12px;
  margin-bottom: 24px;
  display: inline-block;
  max-width: 524px;
`;

export const Wrapper = styled.div``;
